import { render, staticRenderFns } from "./ContactSeoulPage.vue?vue&type=template&id=f3331542&scoped=true&"
import script from "./ContactSeoulPage.vue?vue&type=script&lang=js&"
export * from "./ContactSeoulPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3331542",
  null
  
)

export default component.exports